export class Patient {
  id: number = -1;
  name: string = '';
  gender: string = '';
  age: number = -1;
  birthday: string = '';
  category: string = '';
  origin: string = '';
  phone: string = '';
  email: string = '';
  address: string = '';

  displayName(): string {
    return `${this.id} - ${this.name}`;
  }
}
